import Page from './page';
import FormValidator from '../validator/form_validator';
import CheckoutAddressify from '../checkout/checkout_addressify';
import StickyElem from '../utilities/sticky_elem';
import AddressAnalytics from '../_modules/google_analytics/address';
import { renderFittingStationFinder } from '../_flux/components/fitting_station_finder/fitting_station_finder';
import prepareInitialStation from '../_flux/helper/initial_state_setup/fitting_station';
import ActiveStationActions from '../_flux/actions/active_station_actions';
import LightboxActions from '../_flux/actions/lightbox_actions';
import {
  updatePostcodeAction,
  applyPostcodeAction,
  postcodeInvalidAction,
  postcodeValidAction,
} from '../_flux/actions/postcode_actions';
import { setPostcodeV2 } from '../_flux/helper/requests/set_postcode_v2';
import StationsActions from '../_flux/actions/fitting_station_actions';
import ActiveStationStore from '../_flux/stores/active_station_store';
import MapActions from '../_flux/actions/map_actions';
import MapStore from '../_flux/stores/map_store';
import LightboxStore from '../_flux/stores/lightbox_store';
import FittingStationFinderConstants from '../_flux/constants/fitting_station_finder_constants';
import { createLatLangObjectFromString, getMap } from '../_flux/helper/gmap';
import { sendPageView, setPage } from '../_modules/google_analytics/ga_interface';
import GetParameters from '../utilities/get_parameters';
import { init as initWheelAlignmentInfoLightBox } from '../_views/wheel_alignment_info_light_box/wheel_alignment_info_light_box_view';
import { showAction } from '../_flux/actions/wheel_alignment_info_light_box_actions';
import ProductPage from './product_page';
import { addAction } from '../_flux/actions/products_actions';
import { open } from '../_modules/google_analytics/wheel_alignment_info_light_box';
import { handleTreeStructure } from '../_modules/address/id';
import { ProductsStore } from '../_flux/stores/products_store';
import { types } from '../_constants/product/types';
import { FsfPages } from '../_constants/fsf_pages';
import { hideAction as unlockUi, showAction as lockUi } from '../_flux/actions/ui_lock_actions';
import { init as initUiLock } from '../_views/ui_lock/ui_lock_view';
import { forEachOnObject, preparePaypalTotalPrice } from '../../lib/utilities';
import autoOpenFsf from '../utilities/fsf/auto_open';
import isFSFDisabled from '../_flux/helper/disable_fsf_for_store';
import Scroll from '../utilities/scroll/index';
import { init as initClearanceInfoLightBox } from '../_views/clearance_info_light_box/clearance_info_light_box';
import bindClearanceEvent from '../_flux/helper/clearance_info_click_event';
import { showAutoCompletePostcodeSelector } from '../_flux/components/PostcodeAutocomplete';
import { getPostcodeFromLocalStorage } from '../utilities/local_storage';
import { validatePostcode } from '../validator/PostcodeAutocompleteValidator';
import { initializeTyrePageModules } from './checkout/initialize_page_modules/tyre_page_modules';
import { loadGoogleMapDependencies } from '../_global/initGoogleMapDependencies';
import { init as initSidebarLightBoxView } from '../_views/sidebar/light_box';
import { init as initVoucherCodeLightBox, onClose as voucherCodeLightBoxClose } from '../_views/voucher_code_light_box/voucher_code_light_box_view';
import { redeemVoucher } from '../_flux/helper/requests/redeem_voucher';
import { addLoadingAction, invalidAction, removeLoadingAction, validAction } from '../_flux/actions/voucher_code_light_box_actions';

/**
 * @extends Page
 */
class CheckoutAddressPage extends Page {
  static _name = 'CheckoutAddressPage';

  constructor($container, flashMessages) {
    super($container, flashMessages);

    this.$container = $container;
    this.flashMessages = flashMessages;
    this.$form = $container.find('#addressForm');
    this.$submit = $container.find('input[type="submit"]');
    this.$errorContainer = $container.find('.checkout-address');
    this.$billingAddress = $container.find('#addressForm');
    this.$summaryContainer = $container.find('.checkout-summary');
    this.initialPostcode = this.extractFormPostcode();
    this.getParameters = new GetParameters();
    this.shippingLocation = null;
    this.shippingLocationInitiated = false;

    loadGoogleMapDependencies();
    TYROOLA.mapsInitiated.then(() => {
      if (TYROOLA.globals.store !== 'ID') {
        this.initAddressify();
      }
    });
  }

  /**
   * Run set up
   */
  init() {
    super.init();

    if (this.$container.length) {
      initializeTyrePageModules(this.productType);
    }

    this.initAddressValidation()
      .initSummaryStick()
      .initSubmitHandler()
      .initFittingStationFinder()
      .initWheelAlignmentInfo()
      .handleAddressTreeStructure()
      .initMobileFittingAddress()
      .initEventOnFittingAddress()
      .scrollToMobileErrorContainer();
    initClearanceInfoLightBox(document.getElementById('clearance-info'));

    initSidebarLightBoxView(document.getElementById('sidebar-light-box'), {
      currencyIsoCode: TYROOLA.globals.currencyIsoCode,
    });

    bindClearanceEvent();

    preparePaypalTotalPrice(document.querySelector('.checkout-summary__total span').innerText);
    initVoucherCodeLightBox(document.getElementById('voucher-code'), {
      onRedeem: CheckoutAddressPage.onRedeem.bind(this),
    });
  }

  static async onRedeem(code, checkValidity, recaptchaToken) {
    try {
      lockUi();
      addLoadingAction();
      const res = await redeemVoucher(code, recaptchaToken);
      validAction(res.success.userMessage);

      unlockUi();
      removeLoadingAction();
    } catch (e) {
      const error = e?.responseJSON?.error?.userMessage || '';
      console.log(error);
      invalidAction(error);
      unlockUi();
      removeLoadingAction();
    }
  }

  initMobileFittingAddress() {
    if (TYROOLA.initialFluxStates.initialStation.isMobileFitter) {
      const mobileFittingContainer = document.querySelector('.checkout-mobile-fitting-address');
      if (mobileFittingContainer) {
        const addressType = mobileFittingContainer.querySelectorAll('input[name="addressFittingType"]');
        addressType.forEach((x) => {
          if (x.value === 'different' && x.checked) {
            this._showDifferentBillingAddressContainer(x.checked);
          }
          x.addEventListener('change', this.mobileFittingAddressToggle.bind(this));
        });
      }
    }
    return this;
  }

  updateShippingAddress() {
    setTimeout(() => {
      const street = document.querySelector('#billingStreet');
      const suburb = document.querySelector('#billingCity');
      const postcode = document.querySelector('#billingPostCode');
      const state = document.querySelector('#billingState');
      const addressContainer = document.querySelector('#mobile-fitting-shipping-address');
      if (suburb.value && postcode.value && state.options[state.selectedIndex].innerHTML) {
        addressContainer.textContent = `${street.value}, ${postcode.value}, ${state.options[state.selectedIndex].value
          }`;
      }
    }, 500);
  }

  initEventOnFittingAddress() {
    if (TYROOLA.initialFluxStates.initialStation.isMobileFitter) {
      const elems = document.querySelectorAll('#billingCity, #billingPostCode, #billingState, #billingStreet');
      elems.forEach((e) => {
        e.addEventListener('change', this.updateShippingAddress.bind(this));
      });
    }
    return this;
  }

  _setMobileFittingRequiredStatus(status) {
    const elems = document.querySelectorAll('.mobile-fitting-address');
    elems.forEach((x) => {
      if (status) {
        x.setAttribute('required', 'true');
      } else if (!status) {
        x.removeAttribute('required');
      }
    });
    this.initAddressValidation();
  }

  mobileFittingAddressToggle(event) {
    const { value } = event.target;
    const differentAddressSelector = value === 'different';
    this._showDifferentBillingAddressContainer(differentAddressSelector);
  }

  _showDifferentBillingAddressContainer(value) {
    const addressSection = document.querySelector('.checkout-different-address-input');
    if (value) {
      addressSection.style.display = 'block';
      this._setMobileFittingRequiredStatus(true);
    } else if (!value) {
      addressSection.style.display = 'none';
      this._setMobileFittingRequiredStatus(false);
    }
  }

  initFittingStationFinder() {
    const initialStation = TYROOLA.initialFluxStates.initialStation.id
      ? TYROOLA.initialFluxStates.initialStation
      : null;
    forEachOnObject(TYROOLA.initialFluxStates.products, addAction);
    let fittingNotAvailable = isFSFDisabled();
    forEachOnObject(TYROOLA.initialFluxStates.products, (product) => {
      if (product.type === types.WHEEL) {
        fittingNotAvailable = true;
      }
    });

    if (fittingNotAvailable) {
      TYROOLA.mapsInitiated.then(() => {
        if (TYROOLA.globals.store !== 'ID') {
          this.initAddressify();
        }
      });

      return this;
    }

    prepareInitialStation(initialStation);

    if (initialStation && TYROOLA.initialFluxStates.wheelAlignment2) {
      CheckoutAddressPage._onWheels2Change(TYROOLA.initialFluxStates.wheelAlignment2, true);
    }

    if (initialStation && TYROOLA.initialFluxStates.wheelAlignment4) {
      CheckoutAddressPage._onWheels4Change(TYROOLA.initialFluxStates.wheelAlignment4, true);
    }

    const userShippingAddress =
      TYROOLA.initialFluxStates &&
        Object.prototype.hasOwnProperty.call(TYROOLA.initialFluxStates, 'userShippingAddress') &&
        TYROOLA.initialFluxStates.userShippingAddress &&
        TYROOLA.initialFluxStates.userShippingAddress.postcode
        ? TYROOLA.initialFluxStates.userShippingAddress
        : null;
    if (
      userShippingAddress !== null &&
      userShippingAddress.latitude !== null &&
      userShippingAddress.longitude !== null
    ) {
      this.shippingLocation = {
        lat: parseFloat(userShippingAddress.latitude),
        lng: parseFloat(userShippingAddress.longitude),
      };
    }

    TYROOLA.mapsInitiated.then(() => {
      let visibleState;
      let hasBeenClickedOnce = false;

      renderFittingStationFinder({
        containerDOMNode: document.getElementById('fsf'),
        showSelectStationButton: true,
        showSuccessPage: false,
        showQuantityInput: false,
        showDisplayName: TYROOLA.globals.store === 'ID',
        onStationSelect: this.onStationSelect.bind(this),
        onWheels2Change: CheckoutAddressPage._onWheels2Change,
        onWheels4Change: CheckoutAddressPage._onWheels4Change,
      });

      $('#billingFitting, #out-of-service-area').on('click', (event) => {
        event.preventDefault();
        if (getMap()) {
          const postcode = showAutoCompletePostcodeSelector(TYROOLA.globals.store) ? getPostcodeFromLocalStorage() : userShippingAddress.postcode;
          LightboxActions.totalPagesChangeAction(FsfPages.WITHOUT_SUCCESS_NOTIFICATION);
          if (!hasBeenClickedOnce && userShippingAddress
            && postcode
            && validatePostcode(TYROOLA.globals.store, postcode)) {
            hasBeenClickedOnce = true;
            applyPostcodeAction(postcode);
            this.initShippingLocation();
            if (this.shippingLocation !== null) {
              this.openFSFWithPostcodeAndLocation(postcode, this.shippingLocation);
            } else {
              this.openFSFWithPostcode(postcode);
            }
          } else {
            LightboxActions.openAction();
          }
        }
      });

      if (initialStation) {
        visibleState = LightboxStore.getState().visible;
        LightboxStore.addListener(() => {
          const newVisibleState = LightboxStore.getState().visible;

          if (visibleState !== newVisibleState) {
            visibleState = newVisibleState;

            if (newVisibleState) {
              setPage('/checkout/fitting/');
            } else {
              setPage('/checkout/address/');
            }
            sendPageView();
          }
        });
      }

      autoOpenFsf();
      initUiLock(document.getElementById('ui-lock'));
    });

    return this;
  }

  initShippingLocation() {
    if (this.shippingLocation !== null && this.shippingLocationInitiated === false) {
      const newLocation = createLatLangObjectFromString(this.shippingLocation.lat, this.shippingLocation.lng);
      if (newLocation.lat() !== false && newLocation.lng() !== false) {
        MapActions.setLatLngAction(newLocation);
        this.shippingLocationInitiated = true;
      }
    }
  }

  openFSFWithPostcodeAndLocation(postcode, location) {
    StationsActions.startFetchingStationsAction();
    MapActions.updateLatLngAction(postcode).then(async () => {
      await StationsActions.fetchStationsAction(
        {
          postcode,
          latitude: location.lat,
          longitude: location.lng,
        },
        ProductsStore.getState()
      );
      getMap().updateView();
    });
    LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_FINDER);
    LightboxActions.openAction();
  }

  openFSFWithPostcode(postcode) {
    StationsActions.startFetchingStationsAction();
    LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_FINDER);
    LightboxActions.openAction();

    const lightboxStore = LightboxStore.getState();
    if (FittingStationFinderConstants.LIGHTBOX_PAGE_USAGE_DESCRIPTION === lightboxStore.activePage) {
      lockUi();
    }

    updatePostcodeAction(postcode);
    setPostcodeV2(postcode, true)
      .then(() => {
        postcodeValidAction();
        MapActions.updateLatLngAction(postcode).then(() => {
          const mapStoreState = MapStore.getState();

          StationsActions.fetchStationsAction(
            {
              postcode,
              latitude: mapStoreState.latLng.lat(),
              longitude: mapStoreState.latLng.lng(),
            },
            ProductsStore.getState()
          );
          getMap().updateView();
        });
        unlockUi();
      })
      .catch((result) => {
        unlockUi();
        const responseJson = result?.responseJSON;
        postcodeInvalidAction(responseJson?.userMessage);
        StationsActions.handleFailedStations(null, responseJson);
        LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_USAGE_DESCRIPTION);
      });
  }

  onStationSelect(station) {
    const activeStationStoreState = ActiveStationStore.getState();
    const wheelAlignment2 = activeStationStoreState.wheelAlignment.wheels2.indexOf(station.id) !== -1;
    const wheelAlignment4 = activeStationStoreState.wheelAlignment.wheels4.indexOf(station.id) !== -1;

    lockUi();
    // applyPostcodeAction(station.postcode);
    ActiveStationActions.setActiveStationAction(station, true, wheelAlignment2, wheelAlignment4)
      .then(this.confirmFormSubmission.bind(this, station))
      .catch(unlockUi);
  }

  confirmFormSubmission({ isMobileFitter }) {
    const form = document.querySelector('#addressForm');
    return form && !form.checkValidity() ? this._validateURLAndReload() : this.goToPaymentOptions(isMobileFitter);
  }

  _validateURLAndReload() {
    const url = window.location.href.split('?');
    const params =
      url.length > 1
        ? url[1]
          .split('&')
          .filter((x) => x !== 'fitting=1' && x !== 'view=list')
          .join('&')
        : null;
    const newUrl = params ? `${url[0]}?${params}` : url[0];
    window.location.replace(newUrl);
  }

  goToPaymentOptions(isMobileFitter) {
    let target = 'summary';
    if (!TYROOLA.initialFluxStates.initialStation.isMobileFitter && isMobileFitter) {
      target = 'none';
    }
    this.handleFormSubmission({ target });
  }

  /**
   * @return {CheckoutAddressPage}
   */
  initAddressify() {
    this.addressify = new CheckoutAddressify();
    this.addressify.init();
    this._initMobileFittingAddress();
    return this;
  }

  _initMobileFittingAddress() {
    const inputs = {
      $billingStreet: $('#addressFittingStreet'),
      $billingDisplayStreet: $('#addressFittingDisplayStreet'),
      $billingNumber: $('#addressFittingStreetNumber'),
      $billingPostCode: $('#addressFittingPostcode'),
      $billingCity: $('#addressFittingCity'),
      $billingState: $('#addressFittingState'),
      billingManualTrigger: {
        changeBtn: $('#mobile-fitting-address-manual-change'),
        addressInput: $('.order__step-content--fitting-address-change'),
        addressContainer: $('.fitting-city'),
      },
    };
    this.mobileFittingAddressify = new CheckoutAddressify(inputs);
    this.mobileFittingAddressify.init();
    return this;
  }

  /**
   * @return {CheckoutAddressPage}
   */
  initAddressValidation() {
    this.billingAddressValidator = new FormValidator(this.$billingAddress, this.$errorContainer, this.flashMessages);

    return this;
  }

  /**
   * @return {CheckoutAddressPage}
   */
  initSummaryStick() {
    StickyElem.add(this.$summaryContainer);

    return this;
  }

  /**
   * @return {CheckoutAddressPage}
   */
  initSubmitHandler() {
    this.$submit.on('click', $.proxy(this.handleFormSubmission, this));

    return this;
  }

  initWheelAlignmentInfo() {
    // open light box button
    $('.wheel-alignment-more-info-button').on('click', () => {
      showAction();
      open('Checkout Address Sidebar');
    });

    // light box
    initWheelAlignmentInfoLightBox(document.getElementById('wheel-alignment-info'), {
      onRemove: ProductPage.onRemoveWheelAlignment.bind(this, 'checkout'),
    });
    return this;
  }

  /**
   * @return {CheckoutPage}
   */
  handleFormSubmission(ev) {
    if (ev.preventDefault) {
      ev.preventDefault();
    }
    if (
      typeof ev.target !== 'string' &&
      ev.target.dataset.action &&
      ev.target.dataset.action === 'sendToHome' &&
      TYROOLA.initialFluxStates.initialStation.isMobileFitter
    ) {
      this._setMobileFittingRequiredStatus(false);
    }

    if (this.addressify && this.addressify instanceof CheckoutAddressify && this.addressify.isActive()) {
      return;
    }

    if (!this.billingFormIsValid()) {
      $('html,body').animate({ scrollTop: '100px' });

      if ($('.city').hasClass('hidden')) {
        $('#billing-address-manual-change').trigger('click');
      }
    } else {
      // Add target (homeAddress or fitting)
      let target;

      if (typeof ev.target === 'string') {
        target = ev.target;
      } else if (ev.target) {
        target = ev.target.getAttribute('name');
      } else {
        target = 'fitting';
      }

      this.$form.find('input#target').val(target);

      if (this.initialPostcode !== this.extractFormPostcode()) {
        AddressAnalytics.setPostcode(true);
      }

      Page.formAppendCsrfToken(this.$form);

      this.$form.submit();
    }
  }

  extractFormPostcode() {
    return this.$form.find('[name="billingPostCode"]').val();
  }

  /**
   * @return {Boolean}
   */
  billingFormIsValid() {
    return this.billingAddressValidator.isValid();
  }

  handleAddressTreeStructure() {
    if (TYROOLA.initialFluxStates.isAddressTreeStructure) {
      handleTreeStructure('#billingState', '#billingCity', '#billingArea', '#billingPostCode');
    }

    return this;
  }

  static _onWheels2Change(stationId, isChecked) {
    const action = isChecked ? ActiveStationActions.setWheelAlignment : ActiveStationActions.unsetWheelAlignment;
    action('2', stationId);
  }

  static _onWheels4Change(stationId, isChecked) {
    const action = isChecked ? ActiveStationActions.setWheelAlignment : ActiveStationActions.unsetWheelAlignment;
    action('4', stationId);
  }

  /**
   * @return {Array}
   */
  getTrackerConfig() {
    return super.getTrackerConfig().concat(['CheckoutTracker']);
  }

  scrollToMobileErrorContainer() {
    window.addEventListener('load', () => {
      const errorContainer = document.querySelector('.alert-danger');
      if (errorContainer) {
        setTimeout(() => {
          Scroll(errorContainer);
        }, 100);
      }
    });
    return this;
  }
}

export default CheckoutAddressPage;
